import React, { useCallback, useEffect, useMemo } from 'react';
import { AccountStatus, AutocompleteDropdown, Box, OptionKey, Text } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { useGetEnrollments } from '@/modules/employee/Employee/hooks/useGetEnrollment';
import { DestinationType, LockboxValidationError, lockboxValidationErrorTitle } from '@/modules/employer/components/Lockbox/lockbox.types';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

const AllocateFundsToTheAccount = () => {
  const { editableLockbox, validationErrors, setEditableLockbox } = useLockboxDetailsStore();
  const { data, isLoading } = useGetEnrollments({ employeeId: editableLockbox?.employeeId });

  const openedAccounts = useMemo(() => data?.filter((account) => account.accountStatus === AccountStatus.OPEN), [data]);
  const accountOptions = useMemo(() => openedAccounts?.map((account) => ({
    key: toString(account?.id),
    value: toString(account?.id),
    title: account?.enrollmentTitle,
  })), [openedAccounts]);

  const handleChangeAccountId = useCallback((accountId?: OptionKey) => {
    setEditableLockbox({
      remainder: {
        destinationType: DestinationType.PLAN_ACCOUNT,
        accountId: accountId as string
      },
    });
  }, [setEditableLockbox]);

  const errorType = useMemo(() => {
    return validationErrors?.find((error) => error === LockboxValidationError.ACCOUNT_REQUIRED) as LockboxValidationError | undefined;
  }, [validationErrors]);

  useEffect(() => {
    if (!editableLockbox?.employeeId) {
      handleChangeAccountId(undefined);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editableLockbox?.employeeId]);

  return (
    <Box>
      <Text color="textSecondary">Allocate funds to the account</Text>
      <Box margin={{ top: 'spacing12' }}>
        <AutocompleteDropdown
          testId="employee-account"
          name="employee-account"
          placeholder="Select account"
          value={editableLockbox?.remainder?.accountId}
          onChange={handleChangeAccountId}
          options={accountOptions}
          isLoading={isLoading}
          errorText={errorType ? lockboxValidationErrorTitle?.[errorType] : undefined}
          cleaningInitiator={!editableLockbox?.employeeId}
        />
      </Box>
    </Box>
  );
};

export default AllocateFundsToTheAccount;
